export const API_BASE_PATH = '/api/v1/';
